import { useMemo, useState } from "react";

import { ComboBoxPlain } from "~/components/formElements/ComboBox.tsx";
import { useAllCompanies } from "~/modules/client/api/company/companyQueries.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";

type Props = {
	filterValues: string[];
	onChange: (newCustomerFilter: string[]) => void;
};

const QuotaCustomerFilter = ({ onChange, filterValues }: Props) => {
	const [value, setValue] = useState<string | null>("");
	const {
		data: allClientsData,
	} = useAllCompanies();

	const optionsData = useMemo(() => {
		if (allClientsData) {
			return allClientsData.sort(byObjectProperty("displayName")).map(client => ({
				value: client.id,
				label: client.displayName,
				selected: filterValues.includes(client.id),
			}));
		}
		return [];
	}, [allClientsData, filterValues]);

	const handleCustomerFilterChange = (clientId: string) => {
		if (filterValues.includes(clientId)) {
			onChange(filterValues.filter(id => id !== clientId));
		} else {
			onChange([...filterValues, clientId]);
		}
	};

	return <ComboBoxPlain optionsData={optionsData}
						  placeholder="Kunden auswählen..."
						  inputSize="sm"
						  value={value}
						  onChange={(value) => value ? setValue(value as string) : undefined}
						  onSelect={(value) => value ? handleCustomerFilterChange(value as string) : undefined}
						  allowNew={false}
						  resetOnSelect={true} />;
};

export default QuotaCustomerFilter;
